import { __awaiter } from '../../../external_node_modules/tslib/tslib.es6.js';
import { buildUrl } from '../../../utils/buildUrl.js';
import { makeRequest, METHODS } from '../../baseRequest.js';
import { PLATFORMS } from '../../../constants/platforms.js';
import { PURCHASE_STATUSES } from '../../../constants/purchaseStatuses.js';
import settings from '../../../settings.js';

const EGS_COMMIT_PURCHASE_STATUSES = {
    [PURCHASE_STATUSES.SUCCESS]: 'success',
    [PURCHASE_STATUSES.ERROR]: 'error',
    [PURCHASE_STATUSES.CANCELLED]: 'cancelled',
};
function egsCommitPurchase(transactionId, status, egsTransactionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = buildUrl(settings.egsCommitPurchaseUrl, {
            platform: PLATFORMS.EGS,
            language: settings.language,
            backendUrl: settings.backendUrl,
        });
        return makeRequest(METHODS.POST, url, {
            transactionId,
            egsTransactionId,
            status: EGS_COMMIT_PURCHASE_STATUSES[status],
        });
    });
}

export { egsCommitPurchase };
//# sourceMappingURL=egsCommitPurchase.js.map
